module.exports = __webpack_public_path__ + "static/mobile-shifts-scheduling-app@2x-2137edb73ef1b9d090e588f62448cccc.png";